import axios from 'axios';
import bcrypt from 'bcryptjs-react';

export default () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 1000 * 5,
    headers: { 'x-api-key': bcrypt.hashSync(process.env.REACT_APP_API_KEY, 10) },
  });
